/**
 * @packageDocumentation
 * @module Object
 */
/**
 * From a given object get the value defined at a given path.
 *
 * @param {object} values
 * @param {string[]} path
 *
 * @return {any}
 */
export var getFromBaseFunction = function (values, path) {
    var current = values;
    var length = path.length;
    var index = 0;
    var currentKey;
    while (current != null && index < length) {
        currentKey = path[index];
        index += 1;
        current = current[currentKey];
    }
    return index === length ? current : undefined;
};
//# sourceMappingURL=getFromBaseFunction.js.map